export const initialSorting = [
	{
		id: 'updatedAt',
		desc: true,
	},
];
